import { NavLink, useNavigate, useLocation } from "react-router-dom";
import { Home, Plus, TrendingUp, Users, User } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";
import { cn } from "@/lib/utils";

const NavItem = ({ to, icon: Icon, label, testId }) => {
  const location = useLocation();
  const active = location.pathname === to;
  return (
    <NavLink
      to={to}
      data-testid={testId}
      className={cn(
        "flex flex-col items-center justify-center gap-1 py-3 text-[10px] font-medium transition-colors duration-200 rounded-xl",
        active ? "text-cyan-300" : "text-[hsl(var(--muted-foreground))] hover:text-white"
      )}
    >
      <Icon size={19} strokeWidth={active ? 2.4 : 1.8} />
      <span className="truncate max-w-[64px]">{label}</span>
      <span
        className={cn(
          "h-1 w-1 rounded-full transition-all duration-300",
          active ? "bg-cyan-300" : "bg-transparent"
        )}
      />
    </NavLink>
  );
};

export const BottomNav = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-3 left-1/2 -translate-x-1/2 z-[10000] w-[min(440px,calc(100vw-1.5rem))] rounded-2xl bg-[rgba(11,18,32,0.75)] border border-white/10 backdrop-blur-xl shadow-[0_18px_70px_rgba(0,0,0,0.55)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-5 items-center px-1">
        <NavItem to="/" icon={Home} label={t("nav.home")} testId="bottom-nav-home-link" />
        <NavItem
          to="/progress"
          icon={TrendingUp}
          label={t("nav.progress")}
          testId="bottom-nav-progress-link"
        />
        <div className="flex justify-center">
          <button
            data-testid="bottom-nav-add-button"
            aria-label={t("nav.addAria")}
            onClick={() => navigate("/add")}
            className="-mt-7 h-14 w-14 rounded-2xl bg-cyan-300 text-slate-950 flex items-center justify-center shadow-[0_0_0_1px_rgba(34,211,238,0.25),0_18px_60px_rgba(34,211,238,0.25)] transition-transform duration-200 hover:bg-cyan-200 active:scale-[0.95]"
          >
            <Plus size={26} strokeWidth={2.5} />
          </button>
        </div>
        <NavItem
          to="/community"
          icon={Users}
          label={t("nav.community")}
          testId="bottom-nav-community-link"
        />
        <NavItem
          to="/profile"
          icon={User}
          label={t("nav.profile")}
          testId="bottom-nav-profile-link"
        />
      </div>
    </nav>
  );
};
